<template>
  <VDialogV3
    id="order-positions-registry-dialog"
    :entity="targetDocument"
    position="right"
    hide-footer
    :title="title"
    :loading="false"
  >
    <OrderPositionsRegistry
      class="fill"
      :params="params"
      :hidden-columns="hiddenColumns"
      :state="state"
      :target-document="targetDocument"
      :filter-class="filterClass"
      :show-action-bar="showActionBar"
    />
  </VDialogV3>
</template>


<!-- Прокси над реестром позиции -->

<script lang="ts">
import type BasePageFilter from '@/domains/BasePageFilter/BasePageFilter';
import type Order          from '@/domains/Orders/Order';

import OrderPositionsRegistry from '@/domains/Orders/components/OrderPositionsRegistry/OrderPositionsRegistry.vue';
import OrdersService          from '@/domains/Orders/OrdersService';
import Assembly from "@/domains/Assemblies/Assembly";
import Shipment from "@/domains/Shipments/Shipment";

export default defineComponent({
  name: 'OrderPositionsRegistryDialog',

  components: { OrderPositionsRegistry },

  props: {
    /**
     * Заголовок диалога. Если не передан — дефолтный "Позиции заказов".
     */
    title: {
      type:    String,
      default: 'Позиции заказов',
    },

    /** Параметры запроса позиций (фильтры на уровне API). */
    params: {
      type:    Object as PropType<Parameters<typeof OrdersService.getPositionsListPaginated>[0]>,
      default: null,
    },

    /** Скрытые колонки реестра по id. */
    hiddenColumns: {
      type:    Array as PropType<string[]>,
      default: () => [],
    },

    /** Состояние позиций — фильтр по in-work/finished/received/deleted. */
    state: {
      type:    String,
      default: null,
    },

    /** Класс страничного фильтра (localStorage). */
    filterClass: {
      type:    Function as unknown as () => typeof BasePageFilter,
      default: null,
    },

    /**
     * Наполняемый документ. Если передан — выбор позиций в реестре
     * обогащает targetDocument.positions через его addPosition/deletePosition.
     * Поддерживаются Order / Assembly / Shipment — у всех трёх единый
     * контракт positions / addPosition / deletePosition.
     */
    targetDocument: {
      type: Object as PropType<Order | Assembly | Shipment>,
      default: null,
    },

    showActionBar: {
      type: Boolean,
      default: false
    },
  },
});
</script>
